// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"nft-asset-badges_Wrapper__XWxc_","isPlaying":"nft-asset-badges_isPlaying__zFpCo","Item":"nft-asset-badges_Item__OIt3u","Icon":"nft-asset-badges_Icon__rS_Wb"};